export default function useSessionAuth() {
  return JSON.parse(sessionStorage.getItem("okta-token-storage"))?.accessToken
    ?.accessToken;
}
